import { render, staticRenderFns } from "./SignUser.vue?vue&type=template&id=339c5864&scoped=true"
import script from "./SignUser.vue?vue&type=script&lang=js"
export * from "./SignUser.vue?vue&type=script&lang=js"
import style0 from "./SignUser.vue?vue&type=style&index=0&id=339c5864&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339c5864",
  null
  
)

export default component.exports